import type { BlockExportMapping } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { HomepageBlock1 } from "./HomepageBlock1";
import { HomepageBlock2 } from "./HomepageBlock2";
import { HomepageBlock3 } from "./HomepageBlock3";
import { HomepageBlock4 } from "./HomepageBlock4";
import { HomepageBlock5 } from "./HomepageBlock5";
import { HomepageBlock6 } from "./HomepageBlock6";
import { HomepageBlock7 } from "./HomepageBlock7";
import { HomepageBlock8 } from "./HomepageBlock8";
import { HomepageBlock9 } from "./HomepageBlock9";

export const homepageBlocks: BlockExportMapping = {
  ProfessionalNetworkHomepageBlock1: HomepageBlock1,
  ProfessionalNetworkHomepageBlock2: HomepageBlock2,
  ProfessionalNetworkHomepageBlock3: HomepageBlock3,
  ProfessionalNetworkHomepageBlock4: HomepageBlock4,
  ProfessionalNetworkHomepageBlock5: HomepageBlock5,
  ProfessionalNetworkHomepageBlock6: HomepageBlock6,
  ProfessionalNetworkHomepageBlock7: HomepageBlock7,
  ProfessionalNetworkHomepageBlock8: HomepageBlock8,
  ProfessionalNetworkHomepageBlock9: HomepageBlock9,
};
